import { useSelector } from "react-redux";

import CustomButton from "../../components/CustomButton";
import Inperson from "./inPerson";
import Online from "./online";
import Virtual from "./virtual";
import CorporateWellness from "./corporateWellness";
import WorkoutTabs from "./workoutTabs";
import ReactGA from "react-ga";
import CONSTANTS from "../../utils/constants/CONSTANTS";

import { eventTrack, eventTrackGA4 } from "../../utils/helperFunctions";

import "./index.scss";

const Programs = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
  const currentTab = useSelector((state) => state.programs.tab);

  const handleClick = () => {
    window.open(CONSTANTS.baseUrl, "_blank");
    eventTrack("Redirection To Web Portal", "From Get Started button on Programs Page", "Redirection");
    eventTrackGA4("Redirection To Web Portal", "From Get Started button on Programs Page", "Redirection");
  };
  return (
    <div className="programs">
      <WorkoutTabs />
      {currentTab === CONSTANTS.TABS.IN_PERSON && <Inperson />}
      {currentTab === CONSTANTS.TABS.ONLINE && <Online />}
      {currentTab === CONSTANTS.TABS.VIRTUAL && <Virtual />}
      {currentTab === CONSTANTS.TABS.CORPORATE_WELLNESS && <CorporateWellness />}
      {currentTab !== CONSTANTS.TABS.CORPORATE_WELLNESS ? (
        <div className="btn">
          <CustomButton type={CONSTANTS.ROUNDED_TYPE} handleClick={handleClick}>
            Get started
          </CustomButton>
        </div>
      ) : null}
    </div>
  );
};
export default Programs;
